export default {
  INVESTOR_GOAL_SCHEDULED_DISTRIBUTION_WEALTH_WITHDRAWAL_COMMAND: Symbol.for('INVESTOR_GOAL_SCHEDULED_DISTRIBUTION_WEALTH_WITHDRAWAL_COMMAND'),
  INVESTOR_GOAL_SCHEDULED_DISTRIBUTION_WEALTH_WITHDRAWAL_REPOSITORY: Symbol.for('INVESTOR_GOAL_SCHEDULED_DISTRIBUTION_WEALTH_WITHDRAWAL_REPOSITORY'),
};
